import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

/* ─────────────────────────────────────────────────────────────
   Libellé de champ homogène pour tout le formulaire de déclaration.

   Règle unique et lisible d'un coup d'œil :
     • astérisque rouge  → champ obligatoire
     • pas d'astérisque  → champ facultatif
   Plus de mention « · optionnel » ni de texte d'aide sous le champ :
   le libellé et le placeholder suffisent.
   ───────────────────────────────────────────────────────────── */

export const REQUIRED_MARK_COLOR = '#d92d20';

/** true si la liste de règles AntD contient une contrainte `required`. */
export const rulesAreRequired = (rules) =>
  Array.isArray(rules) && rules.some((r) => r && r.required);

/**
 * Rend un libellé de champ.
 * @param {string} text     libellé affiché
 * @param {boolean} required affiche l'astérisque rouge
 * @param {object} style    surcharges de style
 */
export function fieldLabel(text, required = false, style = {}) {
  return (
    <span
      style={{
        fontSize: 12.5,
        fontWeight: 600,
        color: '#2a3340',
        letterSpacing: '0.01em',
        ...style,
      }}
    >
      {text}
      {required && (
        <span
          aria-hidden="true"
          style={{ color: REQUIRED_MARK_COLOR, fontWeight: 700, marginLeft: 3 }}
        >
          *
        </span>
      )}
    </span>
  );
}

/** Bandeau de légende - affiché une fois par écran, pas par champ. */
export function RequiredLegend({ style = {} }) {
  const { t } = useTranslation('commun');
  return (
    <div style={{ fontSize: 11.5, color: '#8a95a5', ...style }}>
      <Trans
        t={t}
        i18nKey="fieldLabel.legendeObligatoire"
        components={{ 1: <span style={{ color: REQUIRED_MARK_COLOR, fontWeight: 700, margin: '0 3px' }} /> }}
      />
    </div>
  );
}

export default fieldLabel;
